import React from "react";
import {useSelector, useDispatch} from "react-redux";

import {getMiddlefacetGroups} from "../../Store/Actions/NewFilterActions";
import {ACTIVATE_FACET, ADD_TO_AVAILABLE_GROUPS} from "../../Store/Actions/ActionTypes";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import styles from "./MiddleFacet.module.scss";

const MiddleFacet = (props) => {
    const {value, count, id, facetName} = props;
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    // const activeGroup = newFilterState.activeGroup;
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const facets = {...newFilterState.facets};

    const handleClick = () => {
        const facetPayload = {
            id: id,
            value: value,
            facetName: facetName
        };
        dispatch({type: ACTIVATE_FACET, payload: facetPayload});

        const groups = getMiddlefacetGroups(facetName, value);
        for (const [key, item] of Object.entries(groups)) {
            item.middlefacetGroupID = facetName;
            item.middlefacetID = id;
            item.middlefacetValue = value;

            // The facets might have already been fetched from a previous request.
            const cachedMiddlefacetGroup = facets[activeMainFacetID].middlefacets[facetName];
            const cachedMiddlefacet = cachedMiddlefacetGroup.children[id];
            if (cachedMiddlefacet.children !== undefined) {
                // Is the group cached?
                if (cachedMiddlefacet.children[key] !== undefined) {
                    item.children = cachedMiddlefacet.children[key].children;
                }
            }
        }
        const groupsPayload = {
            groups: groups
        };
        dispatch({type: ADD_TO_AVAILABLE_GROUPS, payload: groupsPayload});
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) { // Handle enter
            e.target.click();
        }
    };

    return (
        <div tabIndex="0" className={styles.wrapper} onClick={handleClick} onKeyDown={handleKeyDown}>{value} ({count})</div>
    )
};

export default MiddleFacet;